import { useDispatch } from 'react-redux';
import { verifyTurnstile } from '../Api/authentication';
import { setTurnstileVerified } from '../reduxSlices/globalFlagsSlice';

export const useVerifyTurnstile = () => {
  const dispatch = useDispatch();

  const handleVerify = async (token: string) => {
    try {
      const response = await verifyTurnstile(token);
      if (response.success) {
        dispatch(setTurnstileVerified(true));
      }
    } catch (error) {
      console.error("Error al verificar el turnstile:", error);
    }
  };

  return { handleVerify };
};